<div class="app-toggle-switch">
  <p-toggle-switch
    [formControl]="formControl"
    [readonly]="readonly"
  />

  @if (!!label) {
    <span>{{ label }}</span>
  }
</div>
